<template>
  <div id="app">
    <Agreement />
  </div>
</template>

<script>
import Agreement from './components/Agreement.vue'

export default {
  name: 'app',
  components: {
    Agreement
  },
  mounted() {
    // 从URL参数中获取协议类型并设置页面标题
    const urlParams = new URLSearchParams(window.location.search)
    const type = urlParams.get('type')
    let title = '隐私条款'
    
    switch (type) {
      case 'user':
        title = '用户协议'
        break
      case 'disclaimer':
        title = '免责声明'
        break
      default:
        title = '隐私条款'
    }
    
    document.title = `煜家通智能 - ${title}`
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
